import {
  IOperationDetail,
  IOperationListItem,
  IOperationSaveError,
  IUserIntegrator,
  IUserIntegratorResponse,
  IWebHookConfigHeader,
  IWebhookEvent,
  IWebhookEventQueryParams,
  IWebServiceConfig,
  IWebServiceSaveError
} from '../models/api.model';

export interface IApiConfigurationsInterface {
  users: IUserIntegrator[];
  /** Lista completa de webhooks devuelta por la API v3; la tabla la pagina con un selector. */
  webservice_configs: IWebServiceConfig[];
  /** Lista completa de operaciones propias y compartidas devuelta por la API v3; la tabla la ordena y la pagina con selectores. */
  operations: IOperationListItem[];
  events: IWebhookEvent[];
  /** Webhook abierto en el modal de edicion (API v3); null mientras no hay uno cargado. */
  selected_webservice_config: IWebServiceConfig | null;
  /** Operacion abierta en el modal de edicion (API v3); null mientras no hay una cargada (FR-031). */
  selected_operation: IOperationDetail | null;
  selected_user: IUserIntegratorResponse;
  web_service_sort_params: string;
  operation_sort_params: string;
  user_sort_params: string;
  events_sort_params: Partial<IWebhookEventQueryParams>;
  create_user_errors: { [key: string]: any };
  create_webservice_errors: { [key: string]: any };
  update_user_errors: { [key: string]: any };
  update_webservice_errors: { [key: string]: any };
  create_user: boolean;
  create_webservice: boolean;
  update_user: boolean;
  update_webservice: boolean;
  user_curret_page: number;
  webservice_curret_page: number;
  webservice_configs_headers: IWebHookConfigHeader[];
  /** Pagina (base 1) de la tabla de webhooks; la lista completa se pagina localmente de 10 en 10. */
  webservicePageIndex: number;
  /** Verdadero cuando la ultima peticion de la lista v3 termino con exito. */
  webserviceConfigsLoaded: boolean;
  /** Ultimo error de crear o editar un webhook, mostrado por el modal. */
  webserviceSaveError: IWebServiceSaveError | null;
  /** Pagina (base 1) de la tabla de operaciones; la lista completa se pagina localmente. */
  operationsPageIndex: number;
  /** Tamaño de pagina de la tabla de operaciones: 10, 20, 30 o 40. */
  operationsPageSize: number;
  /** Ultimo error de crear o editar una operacion, mostrado por el modal. */
  operationSaveError: IOperationSaveError | null;
}

export const initialApiConfigurationsState: IApiConfigurationsInterface = {
  users: [],
  webservice_configs: [],
  operations: [],
  events: [],
  web_service_sort_params: 'id:desc',
  operation_sort_params: 'id:desc',
  user_sort_params: 'id:desc',
  events_sort_params: {
    sort: 'id_event:desc',
    page: 1
  },
  selected_webservice_config: null,
  selected_operation: null,
  selected_user: {},
  create_user_errors: {},
  create_webservice_errors: {},
  update_user_errors: {},
  update_webservice_errors: {},
  create_user: false,
  create_webservice: false,
  update_user: false,
  update_webservice: false,
  user_curret_page: 1,
  webservice_curret_page: 1,
  webservice_configs_headers: [],
  webservicePageIndex: 1,
  webserviceConfigsLoaded: false,
  webserviceSaveError: null,
  operationsPageIndex: 1,
  operationsPageSize: 10,
  operationSaveError: null
};
